import React from "react";
import { Link } from "react-router-dom";
import { NoticeI18n } from "@cadenza/i18n-wrappers";
import { FaInfoCircle, FaExternalLinkAlt, FaHome } from "react-icons/fa";
import { MdOutlineFeedback } from "react-icons/md";
import "./About.css";

const About = () => {
  const bgUrl = `${import.meta.env.BASE_URL}riva.jpg`;
  const backgroundStyle = {
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${bgUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100%",
    color: "white",
  };

  const isDev = import.meta.env.DEV;
  // Format build date in non-US (day-month-year) style; e.g., "19 Aug 2025, 14:05"
  const builtDate =
    typeof document !== "undefined" ? new Date(document.lastModified) : null;
  const built =
    builtDate && !Number.isNaN(builtDate?.getTime())
      ? new Intl.DateTimeFormat("en-GB", {
          dateStyle: "medium",
          timeStyle: "short",
        }).format(builtDate)
      : "";

  return (
    <>
      <div className="top-bar"></div>
      <section lang="en" className="main-content">
        <div className="flex-pane" style={backgroundStyle}>
          <div className="overlay"></div>
          <div className="about">
            <header style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <FaInfoCircle className="cs-big-icon" aria-hidden="true" />
              <h2 style={{ margin: 0 }}>About RAD Tool</h2>
            </header>
            <div style={{ margin: "0.5rem 0" }}>
              <strong>Status:</strong>{" "}
              {isDev ? "Development build" : "Production build"}
              {built && (
                <span
                  style={{
                    marginLeft: 8,
                    color: "var(--text-secondary, #888)",
                  }}
                >
                  • Last modified: {built}
                </span>
              )}
            </div>
            <ul style={{ paddingLeft: 18 }}>
              <li>
                Source repository:{" "}
                <a
                  href="https://github.com/MichaelSScott/riva_bpm"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  github.com/MichaelSScott/riva_bpm{" "}
                  <FaExternalLinkAlt
                    className="cs-icon"
                    style={{ verticalAlign: "text-bottom" }}
                  />
                </a>
              </li>
            </ul>
            <p style={{ margin: "0.5rem 0" }}>
              <Link to="/" className="actionButton" aria-label="Back to Home">
                <FaHome className="cs-big-icon" />
              </Link>
            </p>
            <hr style={{ margin: "1rem 0" }} />
            <h2>About this Application </h2>
            <p>
              RAD Tool is part of the riva_bpm workspace. It showcases RAD (Role
              Activity Diagram) flows and components built with the @cadenza/*
              packages.
            </p>
            <p>
              This tool can be used to describe as-is processes, design to-be
              processes, generate operating and training documentation to ISO
              standards, and even provide a route map for IT development. It
              integrates well with strategic business requirements planning and
              goal modelling.
            </p>
            <hr />
            <p>
              This application is very much a work in progress. Don&#39;t expect
              it to be perfect or even finished. If you find bugs or have
              suggestions for improvements you can let me know on the{" "}
              <Link
                to="/feedback"
                className="actionButton"
                aria-label="Open Feedback page"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "2px 8px",
                  marginLeft: 4,
                }}
              >
                <MdOutlineFeedback className="cs-icon" />
                <span>Feedback</span>
              </Link>
              .
            </p>
            <NoticeI18n />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
